/* LaunchDefaultIcon.js */

"use strict";
const ActionableIcon = require("@gluenetworks/steve_ui_core").IconTypes["actionable-icon-gl"];

class LaunchDefaultIcon extends ActionableIcon {
    createdCallback() {
        super.createdCallback(arguments);
    }
}

let icon,
    customElementRegistry = window.customElements;

if (customElementRegistry) {
    icon = customElementRegistry.get("launch-default-icon-gl");
    if (!icon) {
        customElementRegistry.define("launch-default-icon-gl", LaunchDefaultIcon);
        icon = customElementRegistry.get("launch-default-icon-gl");
    }
} else if (document.registerElement) {
    icon = document.registerElement("launch-default-icon-gl", LaunchDefaultIcon);
} else {
    icon = LaunchDefaultIcon;
}

module.exports = icon;
